let inactivityTimer = null;
let visibilityChangeTimer = null;
const INACTIVITY_TIMEOUT = 30 * 60 * 1000; // 30分钟无操作超时
const VISIBILITY_TIMEOUT = 10 * 60 * 1000; // 10分钟离开页面超时

// 保存组件引用
let messageInstance = null;
let routerInstance = null;

// 重置无操作计时器
function resetInactivityTimer() {
  clearTimeout(inactivityTimer);
  inactivityTimer = setTimeout(handleTimeout, INACTIVITY_TIMEOUT);
}

// 重置页面可见性计时器
function handleVisibilityChange() {
  clearTimeout(visibilityChangeTimer);
  
  if (document.hidden) {
    // 页面不可见时启动计时器
    visibilityChangeTimer = setTimeout(handleTimeout, VISIBILITY_TIMEOUT);
  } else {
    // 页面可见时检查是否已超时
    checkTimeoutStatus();
  }
}

// 检查超时状态
function checkTimeoutStatus() {
  const lastActiveTime = localStorage.getItem('lastActiveTime');
  if (!lastActiveTime) return;
  
  const now = new Date().getTime();
  const isInactiveTooLong = now - lastActiveTime > INACTIVITY_TIMEOUT;
  
  if (isInactiveTooLong) {
    handleTimeout();
  } else {
    // 更新最后活动时间并重置计时器
    updateLastActiveTime();
  }
}

// 更新最后活动时间
function updateLastActiveTime() {
  localStorage.setItem('lastActiveTime', new Date().getTime().toString());
}

// 处理超时逻辑
function handleTimeout() {
  // 清除所有缓存
  clearAllStorage();
  
  // 显示超时提示 - 使用正确的Message调用方式
  if (messageInstance) {
    messageInstance.warning('登录已超时，请重新登录');
  }
  
  // 跳转到登录页
  setTimeout(() => {
    if (routerInstance) {
      routerInstance.push('/login');
      // 强制刷新页面确保状态清除
      window.location.reload();
    }
  }, 1500);
}

// 清除所有存储数据
function clearAllStorage() {
  // 备份需要保留的数据
  const backupData = {
    signNo: localStorage.getItem('signNo'),
    signedDates: localStorage.getItem('signedDates'),
    clinicInfo: localStorage.getItem('clinicInfo')
  };
  
  // 清除所有存储
  localStorage.clear();
  sessionStorage.clear();
  
  // 恢复备份数据
  if (backupData.signNo) {
    localStorage.setItem('signNo', backupData.signNo);
  }
  if (backupData.signedDates) {
    localStorage.setItem('signedDates', backupData.signedDates);
  }
  if (backupData.clinicInfo) {
    localStorage.setItem('clinicInfo', backupData.clinicInfo);
  }
  
  // 清除Cookie
  const cookies = document.cookie.split(';');
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i];
    const eqPos = cookie.indexOf('=');
    const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
    document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/';
  }
}

// 初始化超时检测 - 接收Message实例作为参数
export function initTimeoutDetection(router, message) {
  // 保存实例引用
  routerInstance = router;
  messageInstance = message;
  
  // 设置初始活动时间
  updateLastActiveTime();
  
  // 重置无操作计时器
  resetInactivityTimer();
  
  // 监听用户活动
  const activityEvents = [
    'click', 'mousemove', 'keydown', 'scroll', 'touchstart'
  ];
  
  activityEvents.forEach(event => {
    document.addEventListener(event, () => {
      updateLastActiveTime();
      resetInactivityTimer();
    });
  });
  
  // 监听页面可见性变化
  document.addEventListener('visibilitychange', handleVisibilityChange);
  
  // 监听页面关闭/刷新
  window.addEventListener('beforeunload', () => {
    updateLastActiveTime();
  });
}

// 手动触发超时处理（用于测试）
export function triggerTimeout() {
  handleTimeout();
}
// 在文件末尾补充完整的导出
export {
  updateLastActiveTime,  // 确保导出此函数
  resetInactivityTimer   // 确保导出此函数
};